import { EventName, createComponent } from '@lit/react';
import { BlocksPagination } from 'blocks-nextjs/blocks-web-components/components/pagination/pagination';
import { BlocksPageChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';

export const CatPagination = createComponent({
  react: React,
  tagName: 'cat-pagination',
  elementClass: BlocksPagination,
  events: {
    onBlPageChange: 'bl-page-change' as EventName<BlocksPageChangeEvent>
  }
});
